const INCOMING_POPUP_STEPS = {
  incomingInvite: 'incomingInvite',
  accept: 'accepted',
  reject: 'rejected',
  error: 'error',
};

const INVITE_ANSWERS = {
  accept: 'accept',
  reject: 'reject',
};

export {
  INCOMING_POPUP_STEPS,
  INVITE_ANSWERS,
};
